<template>
  <v-dialog 
  v-model="dialog" 
  :content-class="contentClass"
  scrollable 
  transition="c-anim-slide-up-fade"
  :fullscreen="$vuetify.breakpoint.xs" 
  :max-width="viewMode === 'small' ? '400px' : '900px'"
  >

  <v-card>

    <div class="toolbar-pagetop">
      <v-layout pa-2>
        <v-btn
        icon
        @click="close">
          <v-icon color="text">arrow_back</v-icon>
        </v-btn>
        <div class="c-flex-r1 align-center text-sans font-weight-bold">
          Select item
        </div>
        <div style="width: 52px;"></div>
      </v-layout>

      <v-layout 
      v-if="viewMode !== 'table'"
      class="pa-2">
      <!--
        <v-text-field
        v-model="filters.search.name"
        solo
        placeholder="Search..."
        class="crx-box-input"
        color="text"
        hide-details
        @focus="searchMode = true"
        ref="searchBar"
        clearable
        @keydown.down.prevent="focusBelow()"
        @keydown.up.prevent="focusAbove()"
        @keydown.enter.prevent="onEnter()">

        </v-text-field>
        -->
      </v-layout>

    </div>
    
    <!-- DIALOG MAIN CONTENT -->
    <div style="overflow: auto; flex: 1;">

      <!-- secondary header (simple pagination and item count) -->
      <v-layout class="align-center border-b--thin">


        <v-spacer></v-spacer>

        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
            >
              <v-icon>mdi-view-grid</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
            :class="[{'color1--text': viewMode === 'grid'}]"
            @click="setViewMode('grid')">
              <v-list-item-title
              :class="[{'color1--text': viewMode === 'grid'}]">
                Grid
              </v-list-item-title>
            </v-list-item>
            <v-list-item
            @click="setViewMode('table')">
              <v-list-item-title
              :class="[{'color1--text': viewMode === 'table'}]">
                Table
              </v-list-item-title>
            </v-list-item>
            <v-list-item
            @click="setViewMode('small')">
              <v-list-item-title
              :class="[{'color1--text': viewMode === 'small'}]">
                Small
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-layout>
      <!-- !secondary header (simple pagination and item count) -->

      <!-- TABLE MODE -->
      <template v-if="viewMode === 'table'">
        <table-card 
        @onItemSelected="onItemSelected" 
        :exceptions="exceptions"
        :key="nonce"
        ref="tableCard"
        :mergePayload="mergePayload">
        </table-card>
      </template>
      <!-- !TABLE MODE -->
          

      <!-- LIST -->
      <v-layout wrap v-else-if="viewMode === 'grid'">
        <!--
        <v-container fluid>
          <v-row dense>
            <v-col cols="12" sm="6" md="4" lg="4"
            v-for="(item, i) in items" 
            :key="item.id">
              <row
              class="align-self-stretch"
              :item="item"
              :viewMode="viewMode"
              :searchFilters="filters.search"
              :active="currentIndex === i"
              :currentSelection="item.id === currentSelectedID"
              :disabled="exceptions.includes(item.id)"
              @click.native="onItemSelected(item)"
              ></row>
            </v-col>
          </v-row>
        </v-container>
        -->
      </v-layout>
      <!-- END LIST -->

      <template v-else-if="viewMode === 'small'">
        <!--
        <row
        v-for="(item, i) in items" 
        :key="item.id"
        :item="item"
        :viewMode="viewMode"
        :searchFilters="filters.search"
        :active="currentIndex === i"
        :currentSelection="item.id === currentSelectedID"
        :disabled="exceptions.includes(item.id)"
        @click.native="onItemSelected(item)"
        ></row>
        -->
      </template>

    </div><!-- END DIALOG MAIN CONTENT -->

    <!-- BOTTOM TOOLBAR -->
    <div class="border-t--thin">


    </div>
    <!-- !BOTTOM TOOLBAR -->

  </v-card>

  </v-dialog>
</template>

<script>
import TableCard from './table-card'

export default {
  props: {
    exceptions: {
      default: () => [] // [id, id, id]
    },
    currentSelectedID: {
      default: null
    },
    mergePayload: null // optional
    /*
    mergePayload = {
      savedInputs: [],
      items: [],
      mergeMap: {}
    }
    */
  },
  components: {
    TableCard
  },
  data () {
    return {
      viewMode: 'table', // grid, table, small
      dialog: false,
      resolve: null,
      reject: null,
      nonce: 0
    }
  },
  computed: {
    contentClass () {
      return 'c-dialog-border-13' + (this.$vuetify.breakpoint.smAndUp ? ' dialog-height-90vh' : '')
    }
  },
  methods: {
    open () {
      this.dialog = true
      this.nonce++
      this.focusFirstTextView()
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    setViewMode (viewMode) {
      this.viewMode = viewMode
      this.focusFirstTextView()
    },
    focusFirstTextView () {
      this.$nextTick(() => {
        if (this.viewMode === 'table') {
          this.$refs.tableCard.focusFirstTextView()
        } else {
          // this.$refs.searchBar.focus()
        }
      })
    },
    close () {
      this.dialog = false
      this.reject()
    },
    onItemSelected (item) {
      if (this.exceptions.includes(item.id)) {
        return
      }
      if (this.currentSelectedID === item.id) {
        return
      }
      this.resolve(item)
      this.dialog = false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .dialog-height-90vh {
  height: 90vh;
}
</style>
